<template lang="html">
    <div>
        <li class="main-menu__item">
            <router-link v-bind:to="{ name: 'TrackingStatuses'}" v-bind:class="{[settingsLinkActiveClass]: settingLink == 'TrackingStatuses'}">
                <span>Статусы</span>
            </router-link>
        </li>
        <li class="main-menu__item">
            <router-link v-bind:to="{ name: 'Printers'}" v-bind:class="{[settingsLinkActiveClass]: settingLink == 'Printers'}">
                <span>Принтеры</span>
            </router-link>            
        </li>
    </div>
</template>
<script>
    export default {
        name: 'stock-settings-menu',
        sort: 8,
        data() {
            return {
                sort: 8
            }
        },
        created() {},
        computed: {
            settingsLinkActiveClass() {
                return this.$router.options.settingsLinkActiveClass;
            },
            settingLink() {
                if (!this.$route.meta || !this.$route.meta.setting_link) return '';
                return this.$route.meta.setting_link
            }
        }
    }
</script>



// WEBPACK FOOTER //
// SettingsMenu.vue?36f91131